import { Pipe, PipeTransform } from '@angular/core';
import { parseYMDDate } from '../utils/DateOrNullOrUndefined';
import { formatDateToYmd } from '../utils/formatDate';

@Pipe({
  name: 'safeDate',
})
export class SafeDatePipe implements PipeTransform {
  transform(value: string | Date): Date | null {
    if (!value) return null;

    const normalized = formatDateToYmd(value);
    return normalized ? parseYMDDate(normalized) : (value instanceof Date ? value : null);
  }
}
